import type { ConsultationPrescription } from '../../../types/api';
import { activePrescriptions } from '../../consultations/hooks/correctionAccess';

/**
 * "N medicamento(s)" chip on the patient's consultation list. A voided
 * prescription was replaced by a re-issue, so counting it would show two
 * medications where the patient has one (clinical-record-amendments R5).
 */
export function medicationCountLabel(prescriptions: ConsultationPrescription[] | null | undefined): string | null {
  const count = activePrescriptions(prescriptions).length;
  if (count === 0) return null;
  return `${count} medicamento${count !== 1 ? 's' : ''}`;
}
